import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Link from 'next/link';

import { applyCypressData } from 'Utilities/helpers';

import styles from './MenuList.module.scss';

export const MENU_LINK_TYPE = {
	LINK: 'link',
	ROUTE: 'route',
};

const MenuItem = ({
	customIconProps,
	cypressId,
	href,
	icon: Icon,
	linkConfig = {},
	linkType = MENU_LINK_TYPE.ROUTE,
	onClick = noop,
	text,
}) => {
	const isRouteLink = linkType === MENU_LINK_TYPE.ROUTE;

	const cyData = cypressId ? applyCypressData(cypressId) : {};

	const linkProps = {
		className: styles.link,
		href: isRouteLink ? undefined : href,
		onClick,
		...cyData,
		...linkConfig,
	};

	const link = (
		<a {...linkProps}>
			<Icon {...customIconProps} />
			<span>{text}</span>
		</a>
	);

	return (
		<li className={styles.menuItem}>
			{isRouteLink ? (
				<Link legacyBehavior passHref href={href}>
					{link}
				</Link>
			) : (
				link
			)}
		</li>
	);
};

const MenuList = ({ items }) => {
	const listItems = items.map((item) => <MenuItem key={item.id} {...item} />);
	return <ul>{listItems}</ul>;
};

const menuItemProps = {
	customIconProps: {
		filled: PropTypes.bool,
	},
	cypressId: PropTypes.string,
	href: PropTypes.string.isRequired,
	icon: PropTypes.func,
	linkConfig: PropTypes.object,
	linkType: PropTypes.oneOf(Object.values(MENU_LINK_TYPE)),
	onClick: PropTypes.func,
	text: PropTypes.string.isRequired,
};

MenuList.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			...menuItemProps,
		}),
	).isRequired,
};

MenuItem.propTypes = {
	...menuItemProps,
};

export default MenuList;
